import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NWClient } from '../../client/NWClient';
import {
  DocumentHtmlModel,
  DocumentUploadHtmlRequest,
  DocumentUploadHtmlData,
  DocumentUploadHtmlDeleteData,
} from '../../models/document.html.model';
import { revertAll, RootState } from '../../store';

export const fetchDocumentUploadHTML = createAsyncThunk(
  'documentUploadHTML/fetchHTML',
  async ({ data }: DocumentUploadHtmlRequest) => {
    const response = await NWClient.list('document-upload-html', data);
    return response;
  }
);

export const addDocumentUploadHTML = createAsyncThunk(
  'documentUploadHTML/addHTML',
  async ({ data }: DocumentUploadHtmlData) => {
    const response = await NWClient.post('document-upload-html', data);
    return response;
  }
);

export const deleteDocumentUploadHTML = createAsyncThunk(
  'documentUploadHTML/deleteHTML',
  async ({ id, userId }: DocumentUploadHtmlDeleteData) => {
    const response = await NWClient.delete('document-upload-html', id, null, { user: userId });
    return response;
  }
);

export interface DocumentUploadHTMLState {
  documentUploadHTMLList: DocumentHtmlModel[];
  status: string;
  error: string;
}

const initialState: DocumentUploadHTMLState = {
  documentUploadHTMLList: [],
  status: 'idle',
  error: '',
};
const documentUploadHTMLSlice = createSlice({
  name: 'documentUploadHTML',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchDocumentUploadHTML.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDocumentUploadHTML.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (Array.isArray(action.payload)) {
          state.documentUploadHTMLList = [...action.payload];
        }
      })
      .addCase(fetchDocumentUploadHTML.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? '';
      })
      .addCase(addDocumentUploadHTML.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addDocumentUploadHTML.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.documentUploadHTMLList.push(action.payload as DocumentHtmlModel);
      })
      .addCase(addDocumentUploadHTML.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? '';
      })
      .addCase(deleteDocumentUploadHTML.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteDocumentUploadHTML.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.documentUploadHTMLList = [...state.documentUploadHTMLList].filter(
          (el) => el.id !== action.meta.arg.id
        );
      })
      .addCase(deleteDocumentUploadHTML.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? '';
      })
      .addCase(revertAll, () => initialState);
  },
});

export default documentUploadHTMLSlice.reducer;

export const selectAllDocumentUploadHTML = (state: RootState) =>
  state.documentUploadHTML.documentUploadHTMLList;
